// Catalogue visibility uses the same entity permissions as the report routes.
// The API remains authoritative for ownership and manager-only employee access.
export function reportAccess(permissions = {}) {
  // Legacy catalogue metadata is available to report readers; report data stays API scoped.
  const read = (entity) => ['R', 'G'].some((grant) => permissions[entity]?.permission?.includes(grant));
  return {
    operations: read('Orderadmin\\Reports\\Entity\\Report'),
    'billing-report': read('Orderadmin\\Accounts\\Entity\\Account') || read('Orderadmin\\Accounts\\Entity\\Transaction'),
    'billing-diagnostics': read('Orderadmin\\Accounts\\Entity\\Account'),
    'balance-report': read('Orderadmin\\Accounts\\Entity\\Account'),
    'employee-performance': read('Orderadmin\\Reports\\Entity\\Report'),
    categories: read('Orderadmin\\Reports\\Entity\\Category') || read('Orderadmin\\Reports\\Entity\\Report'),
    reportTypes: read('Orderadmin\\Reports\\Entity\\ReportType') || read('Orderadmin\\Reports\\Entity\\Report'),
  };
}
